import { createSlice } from "@reduxjs/toolkit";

/**
 * Slice de Redux para el estado de eliminación y recarga.
 */
export const deleteAndReloadSlice = createSlice({
  name: "deleteAndReload",
  initialState: {
    currentAction: "2",
    reloadDocuments: [],
    reloadDocumentsStatus: "fetch",
  },
  reducers: {
    /**
     * @param {Object} state - Estado actual.
     * @param {{payload: {newAction: string}}} action - Acción con el nuevo valor de currentAction.
     */
    setCurrentAction(state, action) {
      const { newAction } = action.payload;
      state.currentAction = newAction;
    },
  },
  extraReducers(builder) {},
});

/**
 * Selector para obtener la acción actual de eliminación/recarga.
 * @param {Object} state - Estado global de Redux.
 * @returns {string} Valor de currentAction.
 */
export const getCurrentAction = (state) => state.deleteAndReload.currentAction;

export const { setCurrentAction } = deleteAndReloadSlice.actions;

/** El reducer del slice deleteAndReload para ser combinado en el store. */
export default deleteAndReloadSlice.reducer;